import { Injectable } from '@angular/core';
import { TreeItem } from './tree-item.interface';

@Injectable()

export class TreeParser {

  constructor() {}

  public parse(tree: TreeItem[]): TreeItem[] {

    tree = tree.map(item => ({...item}));

    tree.forEach(item => {
      const children = tree.filter(_item => _item.parentId === item.id);
      Object.defineProperty(item, 'children', {value: children});
    });

    return tree.filter(item => item.parentId === 0);

  }

}
